const encodePathValue = (value) => encodeURIComponent(String(value));

export const ENDPOINTS = {
  AUTH: {
    REGISTER: '/api/v1/Auth/register',
    LOGIN: '/api/v1/Auth/token',
    FORGOT_PASSWORD: '/api/v1/Auth/forgot-password',
    RESET_PASSWORD: '/api/v1/Auth/reset-password',
    CHANGE_PASSWORD: '/api/v1/Auth/change-password',
  },

  PRODUCTS: {
    LIST: '/api/v1/Products/search',
    SEARCH: '/api/v1/Products/search',
    NEW: '/api/v1/Products/new',
    SALE: '/api/v1/Products/sale',
    BY_ID: (id) => `/api/v1/Products/${encodePathValue(id)}`,
    IMAGE: '/api/v1/images',
  },

  CATEGORIES: {
    LIST: '/api/v1/categories',
  },

  CART: {
    ADD: '/api/v1/Cart/add',
    GET: '/api/v1/Cart/get',
    UPDATE: '/api/v1/Cart/update',
    REMOVE: '/api/v1/Cart/remove',
    CLEAR: '/api/v1/Cart/clear',
  },

  ORDERS: {
    CREATE: '/api/v1/Order/place',
    TRACK: (orderId) => `/api/v1/Order/track/${encodePathValue(orderId)}`,
    DETAILS: (orderId) => `/api/v1/orders/details/${encodePathValue(orderId)}`,
    PAYMENT_STATUS: (orderId) => `/api/v1/Order/${encodePathValue(orderId)}/payment-status`,
    PAYMENT_STATUS_COMPAT: (orderId) => `/api/v1/Order/payment-status/${encodePathValue(orderId)}`,
    RETRY_PAYMENT: (orderId) => `/api/v1/Order/${encodePathValue(orderId)}/pay`,
    MY_ORDERS: '/api/v1/orders/myorders',
  },

  CHECKOUT: {
    PAYMENT_METHODS: '/api/v1/payment-methods',
    DELIVERY_FEE: '/api/v1/delivery-fee',
  },

  USER: {
    GET_BY_ID: (id) => `/api/v1/User/getuser/${encodePathValue(id)}`,
    GET_BY_USERNAME: (username) => `/api/v1/User/getuser/${encodePathValue(username)}`,
    PROFILE: '/api/v1/User/profile',
    GET_COUNTRIES: '/api/v1/User/countries',
    GET_CITIES: (country) => `/api/v1/User/cities/${encodePathValue(country)}`,
  },

  MESSAGES: {
    CREATE: '/api/v1/Messages',
  },

  SUBSCRIPTIONS: {
    CREATE: '/api/v1/Subscriptions',
    DELETE: '/api/v1/Subscriptions',
  },

  ZONES: {
    BY_LOCATION: '/api/v1/Zones/by-location',
  },

  SETTINGS: {
    SITE: '/api/v1/Settings/site',
    EXCHANGE_RATE: '/api/v1/Settings/exchange-rate',
  },

  STATIONS: {
    LIST: '/api/v1/Stations',
    IMAGE: (fileName) => `/images/${encodePathValue(fileName)}`,
  },

  NOTIFICATIONS: {
    CUSTOMER: '/api/v1/notifications/customer',
    UNREAD_COUNT: '/api/v1/notifications/customer/unread-count',
    MARK_READ: (id) => `/api/v1/notifications/customer/${encodePathValue(id)}/read`,
    MARK_ALL_READ: '/api/v1/notifications/customer/read-all',
  },
};
